import React, { useState } from 'react';
import ColumnVisibilityModal from '../Modals/ColumnVisibilityModal';

const ColumnVisibilityButton = ({ columnVisibility, setColumnVisibility, columnMeta }) => {

  const isActive = false;
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use blue style if button is active or hovered
  const isBlue = isActive || isHovered;

  const handleClick = () => {
    // Open modal and navigate if needed
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          h-[50px] w-[100px] cursor-pointer border-none 
          inline-flex items-center justify-center
          transition-colors duration-300
        `}
        style={{ 
          borderRadius: '25px',
          backgroundColor: isBlue ? '#0832DE' : '#E2E7F3' 
        }}
      >
        <svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* We don't need to include the rect background as it's handled by the button background */}
          
          {/* Skills icon */}
          <path 
            d="M20.75 24C21.9926 24 23 22.9926 23 21.75C23 20.5074 21.9926 19.5 20.75 19.5C19.5074 19.5 18.5 20.5074 18.5 21.75C18.5 22.9926 19.5074 24 20.75 24Z" 
            stroke={isBlue ? "white" : "#2B3674"} 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M27.25 24C28.4926 24 29.5 22.9926 29.5 21.75C29.5 20.5074 28.4926 19.5 27.25 19.5C26.0074 19.5 25 20.5074 25 21.75C25 22.9926 26.0074 24 27.25 24Z" 
            stroke={isBlue ? "white" : "#2B3674"} 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M20.75 30.5C21.9926 30.5 23 29.4926 23 28.25C23 27.0074 21.9926 26 20.75 26C19.5074 26 18.5 27.0074 18.5 28.25C18.5 29.4926 19.5074 30.5 20.75 30.5Z" 
            stroke={isBlue ? "white" : "#2B3674"} 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M27.25 26.5V30" 
            stroke={isBlue ? "white" : "#2B3674"} 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M29 28.25H25.5" 
            stroke={isBlue ? "white" : "#2B3674"} 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          
          {/* Skills text */}
          <path 
            d="M39.08 26.56C39.432 27.648 40.296 28.288 41.704 28.288C42.856 28.288 43.752 27.92 43.752 26.96C43.752 26.112 43.304 25.744 41.368 25.28C38.616 24.624 37.672 23.632 37.672 21.84C37.672 20 39.4 18.624 41.528 18.624C43.624 18.624 45.064 19.584 45.624 21.152L43.784 21.904C43.464 21.024 42.616 20.496 41.576 20.496C40.44 20.496 39.752 20.928 39.752 21.872C39.752 22.64 40.168 22.976 41.976 23.376C44.68 24 45.832 24.976 45.832 26.8C45.832 28.8 44.088 30.16 41.72 30.16C39.512 30.16 37.864 29.104 37.304 27.376L39.08 26.56ZM47.2611 30V18.8H49.2131V25.328L52.3811 22H54.7491L51.3731 25.472L54.8291 30H52.4451L50.0451 26.8L49.1811 27.632V30H47.2611ZM55.8301 22H57.7981V30H55.8301V22ZM55.5901 19.696C55.5901 18.976 56.1181 18.448 56.8221 18.448C57.5261 18.448 58.0541 18.976 58.0541 19.696C58.0541 20.4 57.5261 20.928 56.8221 20.928C56.1181 20.928 55.5901 20.4 55.5901 19.696ZM60.0364 18.8H62.0044V30H60.0364V18.8ZM64.2426 18.8H66.2106V30H64.2426V18.8ZM69.3643 27.44C69.5563 28.128 70.1003 28.464 71.0763 28.464C72.1803 28.464 72.5483 28.144 72.5483 27.68C72.5483 27.136 72.0683 27.088 70.9163 26.848C69.4283 26.544 67.6842 26.128 67.6842 24.272C67.6842 22.88 69.0763 21.84 70.9643 21.84C72.7083 21.84 73.9243 22.544 74.3723 23.744L72.5323 24.4C72.3083 23.824 71.7643 23.552 70.9323 23.552C70.1003 23.552 69.6363 23.808 69.6363 24.288C69.6363 24.784 70.2123 24.96 71.3643 25.216C72.8523 25.536 74.5163 25.952 74.5163 27.632C74.5163 29.152 73.0123 30.16 70.9643 30.16C69.2203 30.16 67.9243 29.392 67.4763 28.064L69.3643 27.44Z" 
            fill={isBlue ? "white" : "#2B3674"}
          />
        </svg>
      </button>
      
      {/* Modal component */}
      <ColumnVisibilityModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          columnMeta={columnMeta}
        />
    </>
  );
};

export default ColumnVisibilityButton;